import { Swiper } from './swiper-DDnfT8S0.js';
import { N as Navigation } from './navigation-DWrRZ7mI.js';
import { P as Pagination } from './pagination-BF_S6uBm.js';
import { A as A11y } from './a11y-DMhWZZ38.js';
import { M as Manipulation } from './manipulation-Bw96zpwn.js';
import './utils-CPPFXbqB.js';
import './create-element-if-not-defined-BweCirD8.js';

class BestsellingProducts extends HTMLElement {
  /** @type {import('swiper').default} */
  #swiperInstance = null;
  /** @type {NodeListOf<HTMLButtonElement>} */
  #tabs = this.querySelectorAll('button[data-controls]');

  get #viewAll() {
    return this.querySelector('[data-slot="view-all"]');
  }

  connectedCallback() {
    this.#initSwiper();
    this.#initTabsSwiper();
    this.#tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.#handleTabClick(tab));
    });
  }

  #initSwiper() {
    this.#swiperInstance = new Swiper(this.querySelector('.swiper--products'), {
      modules: [A11y, Navigation, Manipulation, Pagination],
      slidesPerView: '1.3',
      spaceBetween: 16,
      navigation: {
        prevEl: [...this.querySelectorAll('.swiper-button-prev')],
        nextEl: [...this.querySelectorAll('.swiper-button-next')],
      },
      pagination: {
        el: this.querySelector('.swiper-pagination'),
        clickable: true,
      },
      breakpoints: {
        640: {
          slidesPerView: '2.1',
          spaceBetween: 16,
        },
        768: {
          spaceBetween: 16,
          slidesPerView: '3.1',
        },
        1024: {
          spaceBetween: 16,
          slidesPerView: '4.1',
        },
      },
    });
  }

  #initTabsSwiper() {
    new Swiper(this.querySelector('.swiper--tabs'), {
      modules: [A11y],
      slidesPerView: 'auto',
      spaceBetween: 16,
    });
  }

  #handleTabClick(tab) {
    const target = this.querySelector(`template[id="${tab.dataset.controls}"]`);
    const clone = target.content.cloneNode(true);
    const slides = clone.querySelectorAll('.swiper-slide');
    const viewAll = clone.querySelector('[data-slot="view-all"]');

    this.#tabs.forEach((tab) => tab.classList.replace('button--black', 'button--support'));
    tab.classList.replace('button--support', 'button--black');

    this.#swiperInstance.removeAllSlides();
    this.#swiperInstance.slideTo(0);
    this.#swiperInstance.appendSlide(slides);

    this.#viewAll.replaceWith(viewAll);
  }
}

customElements.define('bestselling-products', BestsellingProducts);
